import { config } from '../../config';
import useIsSupportAdministrationRoute from '../../hooks/useIsSupportAdministrationRoute';
import { addQueryParamsToUrl } from '../../utils/urlUtils';
import { usePartnerNetworkOverviewContext } from './partnerNetworkOverview.context';

/**
 * Put this component outside the Router to avoid unmounting the iframe when navigating.
 * @constructor
 */
const PartnerNetworkOverviewWrapper = () => {
    const { showPartnerNetworkOverview, showOnboarding, showCreateDialog } = usePartnerNetworkOverviewContext();
    const isSupportAdministrationRoute = useIsSupportAdministrationRoute();
    // do not render the partner-network iframe
    if (isSupportAdministrationRoute) {
        return null;
    }

    const offscreenClass = showPartnerNetworkOverview ? '' : 'position-offscreen';

    const baseUrl = (
        showOnboarding ? config.partnerNetworkOverviewOnboardingUrl : config.partnerNetworkOverviewUrl
    ) as string;

    const url = showCreateDialog ? addQueryParamsToUrl(baseUrl, { showCreateDialog: true }) : baseUrl;

    return (
        <iframe
            title='Partner Network Overview'
            name='partner-network-overview'
            className={`unstyled full-window no-application-header ${offscreenClass}`}
            src={url.toString()}
            allow={'clipboard-write'}
        />
    );
};

export default PartnerNetworkOverviewWrapper;
